



















import { Component, Vue, Prop } from "vue-property-decorator";

@Component({ components: {} })
export default class ZoneBackground extends Vue {
  @Prop() readonly alias!: string;
}
